import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
export const InfiniteScrollContainer = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: tailwindMerge("h-100 flex w-full items-center justify-center", className),
        ...props
    });
});
InfiniteScrollContainer.displayName = "InfiniteScrollContainer";
